import { call } from 'redux-saga/effects';
import { AccountResource } from '../../core/resources/account.resource';
import { MembersResource } from '../../core/resources/members.resource';
import { ValidationPasswordResource } from '../../core/resources/validationPassword.resource';
import { accountSerializer } from '../../models/account';
import {
  IApiAccount,
  ICityBirthdatePayload,
  IOptinPayload,
  IPasswordPayload,
} from '../../models/account/account.types';
import {
  EIncludedType,
  IApiMemberProfile,
} from '../../models/member/member.types';
import { memberProfileSerializer } from '../../models/member/memberProfile.serializer';

export function* changePassword(password: IPasswordPayload) {
  // eslint-disable-next-line no-useless-catch
  try {
    yield call(ValidationPasswordResource.validateField, {
      password: password.password,
    });

    return yield call(AccountResource.changeMyPassword, password);
  } catch (error) {
    throw error;
  }
}

export function* getAccount() {
  const apiAccount: IApiAccount = yield call(AccountResource.getMyAccount);

  return accountSerializer(apiAccount).account;
}

export function* getMyProfile(accountId: string, includes: EIncludedType[]) {
  const response: IApiMemberProfile = yield call(
    MembersResource.getMemberByAccountId,
    accountId,
    includes
  );

  return memberProfileSerializer(response.data, response);
}

export function* getOptins() {
  const { attributes } = yield call(AccountResource.getMyOptins);

  return { ...attributes };
}

export function* patchOptin(optin: IOptinPayload) {
  return yield call(AccountResource.patchMyOptin, optin);
}

export function* patchCityBirthdate(payload: ICityBirthdatePayload) {
  return yield call(AccountResource.patchCityAndBirthdateProfile, payload);
}

export function* setPicturePrivacy(picturePrivacy: boolean) {
  return yield call(AccountResource.setPicturePrivacy, picturePrivacy);
}

export function* deleteAccount() {
  return yield call(AccountResource.deleteAccount);
}
